export enum OpenloopAppointmentTypes {
  InitialVisit = "Weight Management - Initial (Visit)",
}

export enum AppointmentStatus {
  Scheduled = "scheduled",
  Occurred = "occurred",
  Confirmed = "confirmed",
  NoShow = "noshow",
  Rescheduled = "rescheduled",
  InProgress = "in_progress",
  CanceledByPatient = "cancelled_by_patient",
  CanceledByProvider = "cancelled_by_provider",
  CanceledSubscription = "cancelled_subscription",
  AwaitingChartingNotes = "awaiting_charting_notes",
  Disqualified = "disqualified",
}

export enum IntakeResults {
  Unset = "unset",
  LabsRequired = "labs_required",
  MedicationApproved = "medication_approved",
  Disqualified = "disqualified",
}

export enum PatientStage {
  Init = "init",
  OrderCreated = "order_created",
  OnboardingComplete = "onboarding_complete",
  AwaitChartingNotes = "await_charting_notes",
  IntakeComplete = "intake_complete",
  RefillIntakeComplete = "refill_intake_complete",
}

export enum MedicationOrderStatus {
  Unset = "unset",
  Created = "created",
  Shipping = "shipped",
  Confirmed = "confirmed",
  OnHoldForLabs = "on_hold_for_labs",
  OnHoldApptRequired = "on_hold_appt_required",
  ConfirmationRequired = "confirmation_required",
}

export enum TreatmentPlanStatus {
  AdditionalSetupRequired = "additionalSetupRequired",
  RefillAvailable = "refillAvailable",
  RefillReceived = "refillReceived",
  ContinueCheckIn = "continueCheckIn",
  CheckInReview = "checkInReview",
  SideEffects = "sideEffects",
  MessageFromProvider = "messageFromProvider",
  AppointmentRequired = "appointmentRequired",
  LabsRequired = "labsRequired",
  TreatmentPlan = "treatmentPlan",
}

export enum LabStatus {
  Unset = "unset",
  Received = "received",
  Completed = "completed",
}
